import { useNavigate } from "react-router-dom";
import Image from "../Image";
import logoImage from '../../../assets/images/logo.png';
import { useAuth } from "context/AuthContext";
import { useGetCurrentSessionUser } from "hooks/useGetCurrentSessionUser";
import { currentSelectedClientType } from "features/Client/useSwitchClientList";
import styles from "./Logo.module.css"

export const brandingImageUrl = (key: string): string =>
  `/auth/readBrandingImage?key=${encodeURIComponent(key)}`;

export default function Logo() {
  const navigate = useNavigate();
  const { user: localUser } = useAuth();
  const currentSelectedClient = useGetCurrentSessionUser<currentSelectedClientType>(
    "currentSelectedClient"
  );

  const clientLogo =
    currentSelectedClient?.clientLogoUrl
      ? brandingImageUrl(currentSelectedClient?.clientLogoUrl)
      : localUser?.clientLogo
        ? brandingImageUrl(localUser?.clientLogo)
        : "";

  return (
    <Image
      src={clientLogo || logoImage}
      alt="Logo"
      className={styles["navbar__logo"]}
      onClick={() => navigate("/")}
    />
  );
}